module.exports = __webpack_public_path__ + "img/l.098e1498.webp";